import { createClient } from '@/prismicio';

/**
 * Simple page fetchers that rely on Prismic's built-in fetch caching.
 * These exist primarily for code organization and potential future optimization.
 * Prismic automatically caches responses with 300s revalidation in production.
 */

export const getHomePage = async () => {
  const client = createClient();
  return await client.getByUID('page', 'home');
};

export const getPageByUID = async (uid: string) => {
  const client = createClient();
  return await client.getByUID('page', uid);
};

export const getBlogByUID = async (uid: string) => {
  const client = createClient();
  return await client.getByUID('blog', uid);
};

export const getWebinarPostByUID = async (uid: string) => {
  const client = createClient();
  return await client.getByUID('webinar_post', uid);
};

// TODO(resources-hub-cleanup): DELETE `getBlogHomeLayout` after the redesign
// release. Once the legacy fallbacks in `(home)/page.tsx` and
// `[uid]/layout.tsx` are removed and the `blog_home_layout` type is deleted in
// Prismic, this helper is unused. (Superseded by `getResourcesHub`.)
export const getBlogHomeLayout = async () => {
  const client = createClient();
  return await client.getSingle('blog_home_layout', {
    fetchLinks: ['author.name', 'author.avatar', 'author.bio'],
  });
};

export const getResourcesHub = async () => {
  const client = createClient();
  return await client
    .getSingle('resources_hub', {
      fetchLinks: ['author.name', 'author.avatar', 'author.bio'],
    })
    .catch(() => null);
};
